export default __webpack_public_path__ + "static/media/avatar.d40c4bed.png";